<template>
  <el-row justify="center" :gutter="10" class="er-multi-range-date-picker">
    <el-col :span="1">
      <el-button size="small" type="primary" circle @click="handlePrevDateClick">Prev</el-button>
    </el-col>
    <el-col :span="4">
      <el-row type="flex" justify="center">{{getNDateTableYears[0]}} {{getNDateTableMonthsName[0]}}</el-row>
      <el-row>
        <er-date-table
          :date="getNDateTableMonths[0]"
          :range-state="rangesState"
          selectionMode="multiple-range"
          :min-date="getDateRanges[0][0]"
          :max-date="getDateRanges[0][1]"
          :current-selected-range="currentEditDateRange"
          @pick="handleRangePick"
        ></er-date-table>
      </el-row>
    </el-col>
    <el-col :span="4">
      <el-row type="flex" justify="center">{{getNDateTableYears[1]}} {{getNDateTableMonthsName[1]}}</el-row>
      <el-row>
        <er-date-table
          :date="getNDateTableMonths[1]"
          :range-state="rangesState"
          :min-date="getDateRanges[0][0]"
          :max-date="getDateRanges[0][1]"
          selectionMode="multiple-range"
          :current-selected-range="currentEditDateRange"
          @pick="handleRangePick"
        ></er-date-table>
      </el-row>
    </el-col>
    <el-col :span="4">
      <el-row type="flex" justify="center">{{getNDateTableYears[2]}} {{getNDateTableMonthsName[2]}}</el-row>
      <el-row>
        <er-date-table
          :date="getNDateTableMonths[2]"
          :range-state="rangesState"
          :min-date="getDateRanges[0][0]"
          :max-date="getDateRanges[0][1]"
          selectionMode="multiple-range"
          :current-selected-range="currentEditDateRange"
          @pick="handleRangePick"
        ></er-date-table>
      </el-row>
    </el-col>
    <el-col :span="1">
      <el-button size="small" type="primary" circle @click="handleNextDateClick">Next</el-button>
    </el-col>
    <el-col :span="10">
      <el-row>
        <el-select
          size="mini"
          :value="computedSelectedDateQuery"
          value-key="id"
          @change="handleOnPickDateQuery"
        >
          <el-option
            v-for="(dateQueryOption,index) in dateQueryOptions"
            :key="index"
            :label="dateQueryOption.text"
            :value="dateQueryOption"
          >{{dateQueryOption.text}}</el-option>
        </el-select>
      </el-row>
      <el-row>
        <er-date-range-input
          :value="getDateRanges[0]"
          type="daterange"
          :class="[isActiveClass(0)]"
          @focus="handleDateRangeInputFocus(0)"
          @input="handleChangeInDateRange($event,0)"
        ></er-date-range-input>
      </el-row>
      <el-row type="flex">
        <el-checkbox></el-checkbox>Compare to:
        <el-select size="mini" :value="dateRange2PickOption">
          <el-option
            :key="'range2'+rangePickOption.id"
            :value="rangePickOption.value"
            v-for="rangePickOption in dateRange2PickOptions"
          >
            {{
            rangePickOption.text
            }}
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <er-date-range-input
          :value="getDateRanges[1]"
          type="daterange"
          :class="[isActiveClass(1)]"
          @focus="handleDateRangeInputFocus(1)"
          @input="handleChangeInDateRange($event,1)"
        ></er-date-range-input>
      </el-row>
      <el-row>
        <el-button size="small" @click="handleApplyEvent">Apply</el-button>
        <el-button size="small" @click="handleCancelEvent">Cancel</el-button>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    noOfRanges: {
      default: 2
    },
    noOfMonthsInView: {
      default: 3
    },
    value: {
      default: () => [
        [new Date(), new Date()],
        [new Date(), new Date()]
      ]
    }
  },
  data: function() {
    return {
      dateIncrementer: 0,
      selectedDateQuery: undefined,
      currentEditDateRange: 0,
      dateRange2PickOption: "",
      dateRanges: [
        [new Date(), new Date()],
        [new Date(), new Date()]
      ],
      rangesState: {}
    };
  },
  computed: {
    getNDateTableMonths() {
      return [
        this.$moment()
          .add(this.dateIncrementer - 1, "month")
          .toDate(),
        this.$moment()
          .add(this.dateIncrementer, "month")
          .toDate(),
        this.$moment()
          .add(this.dateIncrementer + 1, "month")
          .toDate()
      ];
    },
    getNDateTableMonthsName() {
      return [
        this.$moment()
          .add(this.dateIncrementer - 1, "month")
          .month(),
        this.$moment()
          .add(this.dateIncrementer, "month")
          .month(),
        this.$moment()
          .add(this.dateIncrementer + 1, "month")
          .month()
      ].map(monthNumber => {
        return this.$t(`el.datepicker.month${monthNumber + 1}`);
      });
    },
    getNDateTableYears() {
      return [
        this.$moment()
          .add(this.dateIncrementer - 1, "month")
          .year(),
        this.$moment()
          .add(this.dateIncrementer, "month")
          .year(),
        this.$moment()
          .add(this.dateIncrementer + 1, "month")
          .year()
      ];
    },
    computedSelectedDateQuery: function() {
      return this.selectedDateQuery || Object.values(this.dateQueryOptions)[0];
    },
    getDateRanges() {
      return this.dateRanges;
    },

    dateQueryOptions() {
      const getshortCutObj = (
        no,
        unit,
        customText = undefined,
        customId = undefined
      ) => {
        return {
          id: customId || no + unit,
          no,
          unit,
          text:
            customText || `${this.$t("Comn_last")} ${no} ${this.$tc(unit, 2)}`
        };
      };
      return [
        getshortCutObj(0, "days", "Custom", "custom"),
        getshortCutObj(6, "hours"),
        getshortCutObj(2, "days"),
        getshortCutObj(3, "days"),
        getshortCutObj(5, "days"),
        getshortCutObj(1, "months"),
        getshortCutObj(3, "months"),
        getshortCutObj(6, "months")
      ].reduce((acc, option) => {
        acc[option.id] = option;
        return acc;
      }, {});
    },
    dateRange2PickOptions() {
      return [
        { id: "previous_period", text: "Previous Period" },
        { id: "previous_year", text: "Previous Year" },
        { id: "custom", text: "Custom" }
      ];
    },
    isActiveClass() {
      return dateInputID =>
        this.currentEditDateRange === dateInputID ? "is-current-active" : "";
    }
  },
  created() {
    this.initComponent();
  },
  methods: {
    initComponent() {
      const color = ["#fc3", "#0077cc"];
      this.dateRanges = this.value || this.dateRanges;
      this.rangesState = this.dateRanges.reduce((acc, dateRange, index) => {
        acc[index] = {
          startDate: dateRange[0],
          endDate: dateRange[1],
          selecting: false,
          row: null,
          column: null,
          rangeId: index,
          rangeColor: color[index]
        };
        return acc;
      }, {});
    },
    handlePrevDateClick() {
      this.dateIncrementer--;
    },
    handleNextDateClick() {
      this.dateIncrementer++;
    },
    handleChangeInDateRange(value, dateInputID) {
      this.dateRanges.splice(dateInputID, 1, value);
    },
    handleDateRangeInputFocus(dateInputID) {
      this.currentEditDateRange = dateInputID;
    },
    handleOnPickDateQuery(paramSelectedDateQueryOption) {
      this.selectedDateQuery = paramSelectedDateQueryOption;
      const { id, no, unit } = paramSelectedDateQueryOption;
      if (id === "custom") {
        return;
      }
      const getFormat = momentObj => {
        return momentObj.format("YYYY-MM-DD");
      };
      const end = this.$moment();
      const start = this.$moment();
      start.subtract(no, unit);
      const pickedValue = [getFormat(start), getFormat(end)];
      return pickedValue;
    },
    handleRangePick(value) {
      this.rangesState[this.currentEditDateRange].startDate = value.minDate;
      this.rangesState[this.currentEditDateRange].endDate = value.maxDate;
      this.handleChangeInDateRange(
        Object.values(value),
        this.currentEditDateRange
      );
    },
    handleApplyEvent() {
      this.$emit("input", this.dateRanges);
      this.$emit("change", this.dateRanges);
    },
    handleCancelEvent() {
      this.initComponent();
      this.$emit("cancel", this.dateRanges);
    }
  }
};
</script>

<style lang="scss">
.er-multi-range-date-picker {
  .is-current-active {
    border: 1px solid #409eff;
  }
  .in-range-1 {
    color: #fc3;
    > div {
      background-color: #cfffc6;
    }
  }
  .in-range-0 {
    color: #409eff;
    > div {
      background-color: #c6ddff;
    }
  }
  start-date-0 {
  }
  end-date-0 {
  }
}
</style>
